<template>
  <header id="site-header">
    <figure class="logo">
      <a href="/">
        <img src="/images/common/logo.png" alt="logo" />
      </a>
    </figure>

    <div class="menu" @click="trg = !trg">
      <svg v-if="!trg" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M160-269.23v-40h640v40H160ZM160-460v-40h640v40H160Zm0-190.77v-40h640v40H160Z"/></svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M256-227.69 227.69-256l224-224-224-224L256-732.31l224 224 224-224L732.31-704l-224 224 224 224L704-227.69l-224-224-224 224Z"/></svg>
    </div>

    <transition name="fade">
      <nav v-show="trg" class="gnavi" role="navigation" itemscope="itemscope" itemtype="http://scheme.org/SiteNavigationElement">
        <ul>
          <li itemprop="name"><a itemprop="url" href="/security/">ガードワークスのセキュリティ<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-371.69 267.69-584 296-612.31l184 184 184-184L692.31-584 480-371.69Z"/></svg></a></li>
          <!-- 
          <li>
            <dl>
              <dt itemprop="name"><a itemprop="url" href="/product/">カーセキュリティ<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-371.69 267.69-584 296-612.31l184 184 184-184L692.31-584 480-371.69Z"/></svg></a></dt>
              <dd>
                <div>
                  <div itemprop="name" v-for="item, index in list.products" :key="index">
                    <a itemprop="url" :href="item.url">
                      <figure><img :src="item.thumb" :alt="item.name"></figure>
                      <span>{{ item.name }}</span>
                    </a>
                  </div>
                </div>
              </dd>
            </dl>
          </li>
          -->
          <li itemprop="name">
            <dl>
              <dt itemprop="name"><a itemprop="url" href="/cate/car/">車種別情報<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-371.69 267.69-584 296-612.31l184 184 184-184L692.31-584 480-371.69Z"/></svg></a></dt>
              <dd>
                <div>
                  <div itemprop="name" v-for="item, index in list.blog" :key="index">
                    <a itemprop="url" :href="item.url">
                      <figure><img :src="item.thumb" :alt="item.name"></figure>
                      <span>{{ item.name }}</span>
                    </a>
                  </div>
                </div>
              </dd>
            </dl>
          </li>

          <li itemprop="name"><a itemprop="url" href="/guide/">ショップガイド<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-371.69 267.69-584 296-612.31l184 184 184-184L692.31-584 480-371.69Z"/></svg></a></li>
          <li itemprop="name"><a itemprop="url" href="/blog/">ブログ<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M480-371.69 267.69-584 296-612.31l184 184 184-184L692.31-584 480-371.69Z"/></svg></a></li>
        </ul>
      </nav>
    </transition>
    <a href="/contact/" class="btn">CONTACT</a>
  </header>
</template>

<style lang="scss" scoped>
header{
  width: 100%;
  position: fixed;
  padding: 1rem module.side();
  background: module.$black;
  display: grid;
  grid-template-columns: auto auto auto;
  z-index: 1000;
  @media screen and (max-width: module.$tab){
    grid-template-columns: auto auto;
  }
  @media screen and (max-width: module.$phone){
    padding: .8rem module.side();
  }
  > *{
    align-self: center;
  }
  .logo{
    width: 12rem;
    justify-self: flex-start;
    @media screen and (max-width: module.$phone){
      width: 10rem;
    }
    a{
      display: block;
    }
    img{
      width: 100%;
      display: block;
    }
  }
  .menu{
    display: none;
    @media screen and (max-width: module.$tab){
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      display: block;
      position: relative;
      justify-self: flex-end;
      cursor: pointer;
      border: rgba(module.$white, .12) 1px solid;
      transform: translateX(1.6rem);
      svg{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2rem;
        height: 2rem;
        fill: module.$white;
        @media screen and (max-width: module.$phone){
          width: 1.6rem;
          height: 1.6rem;
        }
      }
    }
    @media screen and (max-width: module.$phone){
      width: 3.2rem;
      height: 3.2rem;
    }
    @media screen and (max-width: module.$phone){
      transform: translateX(.8rem);
    }
  }
  nav{
    @media screen and (min-width: calc(#{module.$tab} + 1px)){
      display: block !important;
    }
    @media screen and (max-width: module.$tab){
      position: fixed;
      top: calc(var(--head) - 1px);
      left: 0;
      width: 100%;
      height: calc(100dvh - var(--head) + 1px);
      background: module.$black;
      border-top: rgba(module.$white,.08) 1px solid;
      overflow: auto;
    }
    ul{
      @include module.flex();
      justify-content: center;
      align-items: center;
      @media screen and (max-width: module.$tab){
        display: block;
      }
      li{
        margin: 0 0 0 3.2rem;
        color: module.$gray;
        font-size: .92rem;
        @media screen and (max-width: module.$tab){
          margin: 0;
          font-size: 1.24rem;
          border-bottom: rgba(module.$white,.08) 1px solid;
          &:last-child{
            border: none;
          }
        }
        a{
          color: module.$gray;
          @media screen and (max-width: module.$tab){
            padding: 1.2rem module.side();
            display: block;
            position: relative;
          }
          &:hover{
            color: module.$base;
          }

          svg{
            display: none;
            @media screen and (max-width: module.$tab){
              width: 1.2rem;
              height: 1.2rem;
              fill: module.$white;
              display: block;
              position: absolute;
              top: 50%;
              right: module.side();
              margin: 0;
              transform: translateY(-50%) rotate(-90deg);
            }
          }
        }
        &:first-child{
          margin: 0;
        }
      }
      dl{
        &:hover{
          @media screen and (min-width: calc(#{module.$tab} + 1px)){
            z-index: 3;
            dt{
              &:before{
                display: block;
              }
              a{
                color: module.$base;
                svg{
                  fill: module.$base;
                  transform: translateY(.16rem);
                }
              }
            }
            dd{
              transform: scaleY(1);
              pointer-events: auto;
              opacity: 1;
            }
          }
        }
        dt{
          position: relative;
          z-index: 2;
          a{
            @include module.flex();
            align-items: center;
            justify-content: center;
            @media screen and (max-width: module.$tab){
              justify-content: space-between;
            }
            svg{
              width: 1.2rem;
              height: 1.2rem;
              fill: module.$white;
              display: inline-block;
              margin: 0 0 0 .4rem;
              transition: transform 200ms module.$ease;
            }
          }
          &:before{
            content: '';
            width: calc(100% + 3.2rem);
            height: var(--head);
            position: absolute;
            top: -1.6rem;
            left: 0;
            display: none;
            z-index: -1;
          }
        }
        dd{
          position: absolute;
          z-index: -1;
          opacity: 0;
          pointer-events: none;
          top: calc(var(--head) - 1px);
          left: 0;
          width: 100%;
          background: module.$black;
          border-top: 1px solid rgba(module.$white,.08);
          transform-origin: top center;
          transform: scaleY(.5) rotateX(90deg);
          overflow: hidden;
          transition: all 400ms;
          @media screen and (max-width: module.$tab){
            top: 0;
            position: relative;
            opacity: 1;
            border-top: none;
            transform: translate(0);
            pointer-events: all;
            z-index: 1;
            overflow: auto;
          }
          > div{
            max-width: 88rem;
            padding: 2.4rem module.side();
            margin: 0 auto;
            text-align: left;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 2rem;
            @media screen and (max-width: module.$tab){
              padding: 0;
              grid-template-columns: repeat(2, 1fr);
              gap: 1px;
            }
            > *{
              align-self: center;
            }
            h2{
              color: module.$base;
              border-right: 1px solid rgba(module.$white,.12);
            }
          }
          a{
            display: grid;
            grid-template-columns: 2.8rem 1fr;
            gap: 1rem;
            line-height: 1.5;
            font-size: .92rem;
            @media screen and (max-width: module.$tab){
              background: rgba(module.$normal,.64);
            }
            > *{
              align-self: center;
            }
            figure{
              width: 100%;
              padding: 100% 0 0;
              position: relative;
              border-radius: 50%;
              overflow: hidden;
              img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                top: 0;
                left: 0;
              }
            }
          }
        }
      }
    }
  }
  .btn{
    justify-self: flex-end;
    color: module.$base;
    border: module.$base 1px solid;
    line-height: 1.5;
    padding: .72rem 2.4rem;
    border-radius: 999rem;
    overflow: hidden;
    position: relative;
    display: inline-block;
    z-index: 1;
    transition: color 240ms module.$ease;
    @media screen and (max-width: module.$tab){
      display: none;
    }
    &:before{
      content: '';
      background: module.$base;
      width: 0;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
      z-index: -1;
      transition: width 240ms module.$ease;
    }
    &:hover{
      color: module.$white;
      &:before{
        left: 0;
        right: auto;
        width: 100%;
      }
    }

  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s module.$ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
export default {
  props: {
    list: Object,
  },
  data: function(){
    return {
      trg: false
    }
  },
}
</script>
